module.exports = __webpack_public_path__ + "static/media/WELT POCKETS X3.d2970e98.svg";